module.exports = __webpack_public_path__ + "img/avatar_hover.95102b78.png";